import React from 'react';
import CreatePageVersionForm from '../pageversion/createpageversionform';
import PublishPageVersionForm from '../pageversion/publishpageversionform';
import EditPageVersionForm from '../pageversion/editpageversionform';
import PageVersionEditModal from '../pageversion/pageversioneditmodal';
import UnsavedChangesModal from './unsavedchangedmodal';
import StoresListModal from '../pageversion/storeslistmodal';
import PageVersionDuplicateDrawer from '../pageversion/pageversionduplicatedrawer';
import {
    CreateVersionValues,
    ApprovalValues,
    EditVersionValues,
} from '../../types/types';

interface ModalsAndDrawersProps {
    isCreateDrawerVisible: boolean;
    setIsCreateDrawerVisible: (visible: boolean) => void;
    isPublishDrawerVisible: boolean;
    setIsPublishDrawerVisible: (visible: boolean) => void;
    openEditModal: boolean;
    setOpenEditModal: (visible: boolean) => void;
    isEditPropDrawerVisible: boolean;
    setIsEditPropDrawerVisible: (visible: boolean) => void;
    isModalVisible: boolean;
    setIsModalVisible: (visible: boolean) => void;
    isStoresListVisible: boolean;
    setIsStoresListVisible: (visible: boolean) => void;
    drawerOpen: boolean;
    setDrawerOpen: (visible: boolean) => void;

    pageVersionName: string;
    currentPageVersionGuid: string;
    draftForPublishedPageVersion: string | null;

    handleCreateNewVersion: (values: CreateVersionValues) => Promise<void>
    handleSendForApproval: (values: ApprovalValues) => Promise<void>;
    handleEditPageVersionProperties: (values: EditVersionValues) => Promise<void>;
    updatePageVersionStatusToDraft: () => void;
    handleOkModal: () => void;
    handleCancelModal: () => void;
    handleGotoDraft: () => void;
}

const ModalsAndDrawers: React.FC<ModalsAndDrawersProps> = ({
    isCreateDrawerVisible,
    setIsCreateDrawerVisible,
    isPublishDrawerVisible,
    setIsPublishDrawerVisible,
    openEditModal,
    setOpenEditModal,
    isEditPropDrawerVisible,
    setIsEditPropDrawerVisible,
    isModalVisible,
    setIsModalVisible,
    isStoresListVisible,
    setIsStoresListVisible,
    drawerOpen,
    setDrawerOpen,
    pageVersionName,
    currentPageVersionGuid,
    draftForPublishedPageVersion,
    handleCreateNewVersion,
    handleSendForApproval,
    handleEditPageVersionProperties,
    updatePageVersionStatusToDraft,
    handleOkModal,
    handleCancelModal,
    handleGotoDraft,
}) => {
    return (
        <>
            <CreatePageVersionForm
                open={isCreateDrawerVisible}
                onClose={() => setIsCreateDrawerVisible(false)}
                onCreate={handleCreateNewVersion}
            />
            <PublishPageVersionForm
                open={isPublishDrawerVisible}
                onClose={() => setIsPublishDrawerVisible(false)}
                onPublish={handleSendForApproval}
                pageVersionName={pageVersionName}
                pageVersionGuid={currentPageVersionGuid}
            />
            <EditPageVersionForm
                open={isEditPropDrawerVisible}
                onClose={() => setIsEditPropDrawerVisible(false)}
                onUpdate={handleEditPageVersionProperties}
                pageVersionName={pageVersionName}
            />
            <PageVersionEditModal
                isModalOpen={openEditModal}
                handleCancel={() => setOpenEditModal(false)}
                handlePropertiesClick={() => {
                    setOpenEditModal(false);
                    setIsEditPropDrawerVisible(true);
                }}
                handleContentClick={() => {
                    setOpenEditModal(false);
                    updatePageVersionStatusToDraft();
                }}
                draftForPublished={draftForPublishedPageVersion}
                handleGotoDraft={handleGotoDraft}
            />
            <UnsavedChangesModal
                open={isModalVisible}
                onOk={handleOkModal}
                onCancel={handleCancelModal}
            />
            <StoresListModal
                open={isStoresListVisible}
                onClose={() => setIsStoresListVisible(false)}
                pageVersionGuid={currentPageVersionGuid}
            />
            <PageVersionDuplicateDrawer
                open={drawerOpen}
                sourcePageVersionId={currentPageVersionGuid}
                sourcePageVersionName={pageVersionName}
                onClose={() => setDrawerOpen(false)}
            />
        </>
    );
};

export default ModalsAndDrawers;